export default "__VITE_ASSET__DuyYkSkm__"